import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { restRequest } from '../../../Helpers/RequestHelper';
import Loader from '../../Loader/Loader';
import EnhancedForm from './PaymentModeFormEnhancer';

import './PaymentFormForm.css';
import { checkError } from '../../../Helpers/AuthHelper';
import { t } from 'i18next';
class PaymentModeForm extends Component {
  type = this.props.type; // "add" or "edit" form

  id = this.props.id || null;

  state = {
    paymentMode: {
      name: '',
    },
    loading: true,
  };

  componentDidMount() {
    this.setState({ loading: true });
    this.fetchData().then(() => this.setState({ loading: false }));
  }

  fetchData = async () => {
    if (this.type === 'edit') {
      await restRequest('get', `paymentmethods/${this.id}/edit`)
        .then((res) => {
          let updatedPaymentMode = {
            name: res.name,
          };
          this.setState({ paymentMode: updatedPaymentMode });
        })
        .catch((error) => {
          checkError(error, this.props.handleToast);
        });
    }
  };

  submitRequestType() {
    if (this.type === 'add') {
      return 'post';
    } else if (this.type === 'edit') {
      return 'put';
    }
  }

  submitRequestUrl() {
    if (this.type === 'add') {
      return 'paymentmethods';
    } else if (this.type === 'edit') {
      return `paymentmethods/${this.id}`;
    }
  }

  successMessage = () => {
    if (this.type === 'add') {
      this.props.handleToast(t('common.payment_method_created_successfully'), 'success');
    } else if (this.type === 'edit') {
      this.props.handleToast(t('common.payment_method_updated'), 'success');
    }
  };

  paymentModeContent() {
    const { paymentMode } = this.state;
    const {
      title,
      history,
      inModal,
      closeModal,
      onSubmitModal,
      handleToast,
      totalRecords,
      modelSource = '',
      handleAlertmodal,
    } = this.props;

    return (
      <EnhancedForm
        title={title}
        paymentMode={{ ...paymentMode }}
        requestType={this.submitRequestType()}
        requestUrl={this.submitRequestUrl()}
        onSubmitModal={onSubmitModal}
        successMessage={this.successMessage}
        handleToast={handleToast}
        history={history}
        inModal={inModal}
        modelSource={modelSource}
        totalRecords={totalRecords}
        closeModal={closeModal}
        handleAlertmodal={handleAlertmodal}
      />
    );
  }

  render() {
    if (this.state.loading) return <Loader />;
    return this.paymentModeContent();
  }
}

export default withRouter(PaymentModeForm);
